/**
 * @generated SignedSource<<134fcece85416e1a2f211e6825ec6afa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventConnectionOrder = "CREATED_AT" | "ORDERING_PRIORITY";
export type EventConnectionSortDirection = "ASCENDING" | "DESCENDING";
export type EventStatus = "ACTIVE" | "CLOSED" | "UPCOMING";
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
export type EventQueryFilters = {
  locations?: ReadonlyArray<LocationKind> | null | undefined;
  order?: EventConnectionOrder;
  rewards?: ReadonlyArray<RewardKind> | null | undefined;
  search?: string | null | undefined;
  sortDirection?: EventConnectionSortDirection;
  status?: EventStatus | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type EventsPageQuery$variables = {
  activeFilters?: EventQueryFilters | null | undefined;
  closedFilters?: EventQueryFilters | null | undefined;
  tutorialFilters?: EventQueryFilters | null | undefined;
  upcomingFilters?: EventQueryFilters | null | undefined;
};
export type EventsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventsPageSectionsFragment">;
};
export type EventsPageQuery = {
  response: EventsPageQuery$data;
  variables: EventsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeFilters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "closedFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tutorialFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "upcomingFilters"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "host",
  "plural": false,
  "selections": [
    (v9/*:: as any*/),
    (v10/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    (v11/*:: as any*/),
    (v12/*:: as any*/),
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "RewardConnection",
  "kind": "LinkedField",
  "name": "rewards",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RewardEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Reward",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "kind",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AmountRange",
              "kind": "LinkedField",
              "name": "amount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "start",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "end",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rewards(first:1)"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "TaggableConnection",
      "kind": "LinkedField",
      "name": "tags",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TagEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Tag",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v5/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tags(first:8)"
    }
  ],
  "type": "Taggable",
  "abstractKey": "__isTaggable"
},
v16 = [
  (v4/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventCompetitionConnection",
            "kind": "LinkedField",
            "name": "competitions",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Timeline",
            "kind": "LinkedField",
            "name": "timeline",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v17 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventsPageQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "activeFilters",
            "variableName": "activeFilters"
          },
          {
            "kind": "Variable",
            "name": "closedFilters",
            "variableName": "closedFilters"
          },
          {
            "kind": "Variable",
            "name": "tutorialFilters",
            "variableName": "tutorialFilters"
          },
          {
            "kind": "Variable",
            "name": "upcomingFilters",
            "variableName": "upcomingFilters"
          }
        ],
        "kind": "FragmentSpread",
        "name": "EventsPageSectionsFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "EventsPageQuery",
    "selections": [
      {
        "alias": "tutorial",
        "args": [
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "tutorialFilters"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 3
          }
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v16/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "upcoming",
        "args": [
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "upcomingFilters"
          },
          (v17/*:: as any*/)
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v16/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "active",
        "args": [
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "activeFilters"
          },
          (v17/*:: as any*/)
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v16/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "closed",
        "args": [
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "closedFilters"
          },
          (v17/*:: as any*/)
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v16/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EventCompetition",
        "kind": "LinkedField",
        "name": "eventCompetitionPinned",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Competition",
            "kind": "LinkedField",
            "name": "competition",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionMembership",
                "kind": "LinkedField",
                "name": "membership",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "entity",
                    "plural": false,
                    "selections": [
                      (v9/*:: as any*/),
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*:: as any*/),
              (v15/*:: as any*/),
              (v14/*:: as any*/)
            ],
            "storageKey": null
          },
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63d804f1c27721ec80f6bc3fb43ceffc",
    "id": null,
    "metadata": {},
    "name": "EventsPageQuery",
    "operationKind": "query",
    "text": "query EventsPageQuery(\n  $tutorialFilters: EventQueryFilters\n  $upcomingFilters: EventQueryFilters\n  $activeFilters: EventQueryFilters\n  $closedFilters: EventQueryFilters\n) {\n  ...EventsPageSectionsFragment_3IAOXU\n}\n\nfragment ActivityCardHostFragment on Entity {\n  __isEntity: __typename\n  username\n  ...EntityProfilePicFragment_49kWkb\n}\n\nfragment ActivityCardTagListFragment on Taggable {\n  __isTaggable: __typename\n  tags(first: 8) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment CompetitionCardFooterFragment on Competition {\n  rewards(first: 1) {\n    totalCount\n    edges {\n      node {\n        ...RewardFragment\n        id\n      }\n    }\n  }\n}\n\nfragment CompetitionCardFragment on Competition {\n  id\n  slug\n  title\n  thumbnail\n  shortDescription\n  membership {\n    id\n    entity {\n      __typename\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  host {\n    __typename\n    ...ActivityCardHostFragment\n    id\n  }\n  ...ActivityCardTagListFragment\n  ...CompetitionCardFooterFragment\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment EventCardFooterFragment on Event {\n  rewards(first: 1) {\n    totalCount\n    edges {\n      node {\n        ...RewardFragment\n        id\n      }\n    }\n  }\n}\n\nfragment EventCardFragment on Event {\n  id\n  slug\n  title\n  thumbnail\n  visibility\n  host {\n    __typename\n    ...ActivityCardHostFragment\n    id\n  }\n  competitions {\n    totalCount\n  }\n  ...EventCardFooterFragment\n  ...ActivityCardTagListFragment\n  ...EventLocationFragment\n}\n\nfragment EventLocationFragment on Event {\n  timeline {\n    timezone\n    startDate\n    endDate\n    locationKind\n    location {\n      country\n      city\n      id\n    }\n    id\n  }\n}\n\nfragment EventsCarouselFragment on EventConnection {\n  edges {\n    node {\n      id\n      ...EventCardFragment\n    }\n  }\n}\n\nfragment EventsPageSectionsFragment_3IAOXU on Query {\n  tutorial: events(first: 3, filters: $tutorialFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  upcoming: events(first: 10, filters: $upcomingFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  active: events(first: 10, filters: $activeFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  closed: events(first: 10, filters: $closedFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  ...TrackOfTheMonthFragment\n}\n\nfragment RewardFragment on Reward {\n  id\n  kind\n  amount {\n    start\n    end\n  }\n}\n\nfragment TrackOfTheMonthFragment on Query {\n  eventCompetitionPinned {\n    event {\n      slug\n      id\n    }\n    competition {\n      ...CompetitionCardFragment\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ba4a741d0fe2a18543ffdcf07a2569a";

export default node;
